module.exports = __webpack_public_path__ + "static/img/home.548ed886.svg";